<div class="container-progress-bar container-fluid px-0">
    <div class="row w-100 container-progress gx-7 flex-nowrap">
        <div
            [ngClass]="{
                opened: datetimeSelected,
                selected: status === 'datetime',
                'col-4': status === 'datetime' || status === 'vehicle',
                'col-3': status === 'extras' || status === 'total'
            }"
            class="col-xl-4"
        >
            <div
                [ngClass]="{
                    'different-locations': reservation.showDifferenteLocation
                }"
                class="content-col"
            >
                <button
                    [ngClass]="{ 'prevent-click': disabled }"
                    class="btn-container-step container-fluid d-flex flex-column justify-content-center gx-4 gx-lmd-9 pe-10"
                    (click)="onClickDatetime()"
                >
                    <div class="row">
                        <div class="col-auto">
                            <div
                                class="title-progress-bar d-flex justify-content-center align-items-center"
                            >
                                <img
                                    [src]="'images/check-arrow.svg' | cdn"
                                    alt="icon-arrow"
                                />
                                <span class="title-progress-bar-content">{{
                                    'fe_core_progress_bar_span_title_datetime'
                                        | translate
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="row w-100 gx-8 align-items-center container-title-progress-bar-values"
                    >
                        <div
                            class="col-auto title-progress-bar-values text-truncate d-none d-xxle-flex"
                        >
                            {{
                                reservation.startDatetime
                                    | formatDate: dateFormatProgressBar
                            }}
                        </div>
                        <div
                            class="col-auto title-progress-bar-values text-truncate d-block d-xxle-none"
                        >
                            {{
                                reservation.startDatetime
                                    | formatDate: dateFormatProgressBarShort
                            }}
                        </div>
                        <div
                            [ngClass]="{
                                'd-lmd-block': status === 'vehicle',
                                'd-lmds-block':
                                    status === 'extras' || status === 'total'
                            }"
                            class="col-auto d-none"
                        >
                            <img
                                [src]="'images/arrow-alt-right.svg' | cdn"
                                alt="icon-arrow"
                                class="title-progress-bar-arrow"
                            />
                        </div>
                        <div
                            class="col-auto title-progress-bar-values text-truncate d-none d-xxle-flex"
                        >
                            {{
                                reservation.endDatetime
                                    | formatDate: dateFormatProgressBar
                            }}
                        </div>
                        <div
                            class="col-auto title-progress-bar-values text-truncate d-block d-xxle-none"
                        >
                            {{
                                reservation.endDatetime
                                    | formatDate: dateFormatProgressBarShort
                            }}
                        </div>
                    </div>
                </button>
            </div>
        </div>
        <div
            [ngClass]="{
                opened: locationOpened,
                selected: status === 'location',
                'col-4': status === 'datetime' || status === 'vehicle',
                'col-3': status === 'extras' || status === 'total'
            }"
            class="col-xl-3"
        >
            <div
                [ngClass]="{
                    'different-locations': reservation.showDifferenteLocation
                }"
                class="content-col"
            >
                <button
                    [ngClass]="{ 'prevent-click': disabled }"
                    class="btn-container-step container-fluid d-flex flex-column justify-content-center gx-4 gx-lmd-9 pe-10"
                    (click)="onClickLocation()"
                >
                    <div class="row">
                        <div class="col-auto">
                            <div
                                class="title-progress-bar d-flex justify-content-center align-items-center"
                            >
                                <img
                                    [src]="'images/check-arrow.svg' | cdn"
                                    alt="icon-arrow"
                                />
                                <span
                                    *ngIf="!reservation.showDifferenteLocation"
                                    class="title-progress-bar-content d-none d-lmds-block"
                                    >{{
                                        'fe_core_progress_bar_span_title_location-differentlocation'
                                            | translate
                                    }}</span
                                >
                                <span
                                    *ngIf="!reservation.showDifferenteLocation"
                                    class="title-progress-bar-content d-block d-lmds-none"
                                    >{{
                                        'fe_core_progress_bar_span_title_short_location-differentlocation'
                                            | translate
                                    }}</span
                                >
                                <span
                                    *ngIf="reservation.showDifferenteLocation"
                                    class="title-progress-bar-content"
                                    >{{
                                        'fe_core_progress_bar_span_title_short_location-differentlocation'
                                            | translate
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>
                    <div
                        class="row w-100 gx-8 align-items-center container-title-progress-bar-values"
                    >
                        <div
                            class="col-auto title-progress-bar-values text-truncate"
                        >
                            <!-- {{ reservation.locationName }} -->
                            {{ defaultLocation || reservation.locationName }}
                        </div>
                        <div
                            *ngIf="reservation.showDifferenteLocation"
                            class="col-auto d-none"
                            [ngClass]="{
                                'd-lmd-block': status === 'vehicle',
                                'd-lg-block':
                                    status === 'extras' || status === 'total'
                            }"
                        >
                            <img
                                [src]="'images/arrow-alt-right.svg' | cdn"
                                alt="icon-arrow"
                                class="title-progress-bar-arrow d-none d-xl-block"
                            />
                        </div>
                        <div
                            *ngIf="reservation.showDifferenteLocation"
                            class="col-auto title-progress-bar-values text-truncate"
                        >
                            {{ reservation.differentLocationName }}
                        </div>
                    </div>
                </button>
            </div>
        </div>
        <div
            [ngClass]="{ selected: status === 'vehicle' }"
            class="col-2 col-lmd-auto flex-grow-1"
        >
            <div
                [ngClass]="{
                    'different-locations': reservation.showDifferenteLocation
                }"
                class="content-col"
            >
                <button
                    [ngClass]="{ 'prevent-click': disabled }"
                    class="btn-container-step container-fluid d-flex flex-column justify-content-center gx-4 gx-lmd-9 pe-10"
                    (click)="onClickVehicle()"
                >
                    <div class="row">
                        <div class="col-auto">
                            <div
                                class="title-progress-bar d-flex justify-content-center align-items-center"
                            >
                                <img
                                    *ngIf="
                                        status === 'extras' ||
                                        status === 'total'
                                    "
                                    [src]="'images/check-arrow.svg' | cdn"
                                    alt="icon-arrow"
                                />
                                <span class="title-progress-bar-content">{{
                                    'fe_core_progress_bar_span_title_vehicle'
                                        | translate
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="status === 'vehicle'"
                        class="row w-100 gx-8 align-items-center container-title-progress-bar-values"
                    >
                        <div class="col-auto title-progress-bar-values">
                            {{
                                'fe_core_progress_bar_span_title_current-step'
                                    | translate
                            }}
                        </div>
                    </div>
                    <div
                        *ngIf="
                            reservation?.vehicle !== null &&
                            status !== 'vehicle'
                        "
                        class="row w-100 gx-8 align-items-center container-title-progress-bar-values"
                    >
                        <div
                            class="col-auto title-progress-bar-values text-truncate"
                        >
                            {{ reservation.vehicle?.name }}
                        </div>
                    </div>
                </button>
            </div>
        </div>
        <div
            [ngClass]="{ selected: status === 'extras' }"
            class="col-2 col-lmd-auto flex-grow-1"
        >
            <div
                [ngClass]="{
                    'different-locations': reservation.showDifferenteLocation
                }"
                class="content-col"
            >
                <button
                    [ngClass]="{ 'prevent-click': disabled }"
                    (click)="onClickExtras()"
                    class="btn-container-step container-fluid d-flex flex-column justify-content-center gx-4 gx-lmd-9 pe-10"
                >
                    <div class="row">
                        <div class="col-auto">
                            <div
                                class="title-progress-bar d-flex justify-content-center align-items-center"
                            >
                                <img
                                    *ngIf="
                                        status === 'total' &&
                                        !isWithoutProtection
                                    "
                                    [src]="'images/check-arrow.svg' | cdn"
                                    alt="icon-arrow"
                                />
                                <svg
                                    *ngIf="isWithoutProtection"
                                    class="title-progress-bar-warning"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 16 16"
                                    aria-hidden="true"
                                >
                                    <circle
                                        cx="8"
                                        cy="8"
                                        r="7"
                                        fill="none"
                                        stroke="#fef100"
                                        stroke-width="2"
                                    />
                                    <rect
                                        x="7"
                                        y="3.5"
                                        width="2"
                                        height="5.5"
                                        rx="1"
                                        fill="#fef100"
                                    />
                                    <circle
                                        cx="8"
                                        cy="11.75"
                                        r="1.25"
                                        fill="#fef100"
                                    />
                                </svg>
                                <span class="title-progress-bar-content">{{
                                    'fe_core_progress_bar_span_title_extras'
                                        | translate
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="row w-100 gx-8 align-items-center container-title-progress-bar-values"
                    >
                        <div
                            *ngIf="status !== 'extras' && status !== 'total'"
                            class="col-auto title-progress-bar-values invisible"
                        >
                            {{
                                'fe_core_progress_bar_span_title_extra'
                                    | translate
                            }}
                        </div>
                        <div
                            *ngIf="status === 'extras'"
                            class="col-auto title-progress-bar-values"
                        >
                            {{
                                'fe_core_progress_bar_span_title_current-step'
                                    | translate
                            }}
                        </div>
                        <div
                            *ngIf="status === 'total'"
                            class="col-auto title-progress-bar-values text-truncate"
                            [class.title-progress-bar-values--warning]="
                                isWithoutProtection
                            "
                        >
                            {{
                                isWithoutProtection
                                    ? ('fe_core_progress_bar_span_value_without_protection'
                                      | translate)
                                    : reservation.insurances[0]?.title
                            }}
                        </div>
                    </div>
                </button>
            </div>
        </div>
        <div
            *ngIf="status === 'extras' || status === 'total'"
            [ngClass]="{ selected: status === 'total' }"
            class="col-auto col-total flex-grow-1"
        >
            <div
                [ngClass]="{
                    'different-locations': reservation.showDifferenteLocation
                }"
                class="content-col total"
            >
                <div
                    class="container-fluid d-flex flex-column justify-content-center gx-4 gx-lmd-9 pe-10"
                >
                    <div class="row">
                        <div class="col-auto">
                            <div
                                class="title-progress-bar d-flex justify-content-center align-items-center"
                            >
                                <span class="title-progress-bar-content">{{
                                    'fe_core_progress_bar_span_title_total'
                                        | translate
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="row w-100 gx-8 align-items-center container-title-progress-bar-values"
                    >
                        <div
                            *ngIf="reservation.total !== undefined"
                            class="col-auto title-progress-bar-values text-truncate"
                        >
                            ${{ displayTotal | number: totalDigitsInfo:'en-IN' }}
                            {{ currency }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
        [ngClass]="{ 'd-none': !datetimeOpened }"
        class="container-datetime d-flex align-items-center"
    >
        <div class="container-fluid">
            <div class="row gx-2 d-flex justify-content-center">
                <div class="col-5 col-lg-4 title-progress-bar-selected">
                    {{
                        'fe_core_progress_bar_selected_div_title_datetimes'
                            | translate
                    }}
                </div>
                <div class="col-2 col-lg-1"></div>
                <div class="col-1"></div>
                <div class="col-2"></div>
                <div class="col-2 col-lg-auto">
                    <fe-button
                        class="d-grid mb-sm-0 mb-6 btn-search-reservation invisible"
                        [btnClass]="'px-9'"
                        [style]="'primary'"
                        [type]="'button'"
                    >
                        {{
                            'fe_core_progress_bar_selected_button_update'
                                | translate
                        }}
                    </fe-button>
                </div>
            </div>
            <form [formGroup]="formDatetime">
                <div class="row gx-2 d-flex justify-content-center">
                    <div class="col-3 col-lg-2 pe-7">
                        <fe-input
                            #inputStartDate
                            [ngClass]="{
                                'mb-6': !formDatetime.hasError(
                                    'differenceDatesOut'
                                )
                            }"
                            [id]="'startDate'"
                            [label]="
                                'fe_core_progress_bar_selected_label_start-date'
                                    | translate
                            "
                            [formatDate]="inputDatePickerFormat"
                            [setDateRange]="'start'"
                            [isRangeDate]="true"
                            [mask]="'00/00/0000'"
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            (fromDateChange)="onFromDateChange($event)"
                            (isSelectingChange)="isSelectingChange($event)"
                            [formControlName]="'startDate'"
                            [(ngModel)]="reservation.current.startDate"
                        ></fe-input>
                        <fe-form-control-feedback
                            [flowPage]="'progressBar'"
                            [ngClass]="{
                                'mb-6':
                                    formDatetime.hasError(
                                        'differenceDatesOut'
                                    ) ||
                                    formDatetime.hasError('differenceDatesIn')
                            }"
                            class="d-flex"
                            [renderComponentInvalid]="true"
                            [errors]="
                                formDatetime.hasError('differenceDatesOut')
                                    ? {
                                          differenceDatesOut:
                                              formDatetime.getError(
                                                  'differenceDatesOut'
                                              )
                                      }
                                    : formDatetime.hasError('differenceDatesIn')
                                      ? {
                                            differenceDatesIn:
                                                formDatetime.getError(
                                                    'differenceDatesIn'
                                                )
                                        }
                                      : []
                            "
                        ></fe-form-control-feedback>
                    </div>
                    <div class="col-2 ps-7 ps-lmd-0">
                        <fe-input
                            #inputStartHour
                            class="mb-6"
                            [isSelect]="true"
                            [label]="
                                'fe_core_progress_bar_selected_label_start-hour'
                                    | translate
                            "
                            [items]="reservation.startHours"
                            [formControlName]="'startHour'"
                            [(ngModel)]="reservation.current.startHour"
                            (ngModelChange)="onFromHourChange()"
                            [loading]="loadingStartHours"
                            [disabled]="
                                !formDatetime.get('startDate')?.valid ||
                                reservation.startHours.length === 0
                            "
                        ></fe-input>
                    </div>
                    <div class="col-3 col-lg-2 pe-7">
                        <fe-input
                            #inputEndDate
                            class="mb-6"
                            [id]="'endDate'"
                            [label]="
                                'fe_core_progress_bar_selected_label_end-date'
                                    | translate
                            "
                            [formatDate]="inputDatePickerFormat"
                            [setDateRange]="'end'"
                            [isRangeDate]="true"
                            [mask]="'00/00/0000'"
                            [fromDate]="fromDate"
                            [toDate]="toDate"
                            (toDateChange)="onToDateChange($event)"
                            (isSelectingChange)="isSelectingChange($event)"
                            [(ngModel)]="reservation.current.endDate"
                            [formControlName]="'endDate'"
                            [disabled]="!formDatetime.get('startHour')?.valid"
                        ></fe-input>
                    </div>
                    <div class="col-2 ps-7 ps-lmd-0">
                        <fe-input
                            #inputEndHour
                            [ngClass]="{
                                'mb-6': !formDatetime.hasError('lessThanDate')
                            }"
                            [isSelect]="true"
                            [label]="
                                'fe_core_progress_bar_selected_label_end-hour'
                                    | translate
                            "
                            [items]="reservation.endHours"
                            [formControlName]="'endHour'"
                            [(ngModel)]="reservation.current.endHour"
                            [loading]="loadingEndHours"
                        ></fe-input>
                        <fe-form-control-feedback
                            [flowPage]="'progressBar'"
                            [ngClass]="{
                                'mb-6': formDatetime.hasError('lessThanDate')
                            }"
                            class="d-flex"
                            [renderComponentInvalid]="true"
                            [errors]="
                                formDatetime.hasError('lessThanDate')
                                    ? {
                                          lessThanDate:
                                              formDatetime.getError(
                                                  'lessThanDate'
                                              )
                                      }
                                    : []
                            "
                        ></fe-form-control-feedback>
                    </div>
                    <div class="col-2 col-lg-auto">
                        <fe-button
                            class="d-flex mb-sm-0 mb-6 btn-search-reservation"
                            [btnClass]="
                                'px-lmd-9 d-flex justify-content-center align-items-center d-lg-block p-0 w-lmd-100'
                            "
                            [style]="'primary'"
                            [type]="'button'"
                            [loading]="loadingUpdate"
                            (onClick)="onClickUpdateDatetime()"
                        >
                            {{
                                'fe_core_progress_bar_selected_button_update'
                                    | translate
                            }}
                        </fe-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div
        [ngClass]="{ 'd-none': !locationOpened }"
        class="container-locations d-none d-flex align-items-center"
    >
        <div class="container">
            <div class="row gx-2 d-flex justify-content-center">
                <div class="col-10 col-lg-9 title-progress-bar-selected">
                    {{
                        'fe_core_progress_bar_selected_div_title_office'
                            | translate
                    }}
                </div>
                <div class="col-2 col-lg-auto">
                    <fe-button
                        class="d-grid mb-sm-0 mb-6 btn-search-reservation invisible"
                        [btnClass]="'px-9'"
                        [style]="'primary'"
                        [type]="'button'"
                    >
                        {{
                            'fe_core_progress_bar_selected_button_update'
                                | translate
                        }}
                    </fe-button>
                </div>
            </div>
            <form [formGroup]="formLocations">
                <div class="row gx-2 d-flex justify-content-center">
                    <div class="col-10 col-lg-9">
                        <fe-input
                            #location
                            [ngClass]="
                                reservation.showDifferenteLocation
                                    ? 'mb-6'
                                    : 'mb-0 mb-md-6'
                            "
                            [isSelect]="true"
                            [isSelectLocations]="true"
                            [id]="'location'"
                            [label]="
                                'fe_core_progress_bar_selected_label_location'
                                    | translate
                            "
                            [buttonsAfter]="
                                reservation.showDifferenteLocation
                                    ? []
                                    : [
                                          {
                                              text:
                                                  ('fe_core_progress_bar_selected_btn_back-location'
                                                  | translate),
                                              icon: 'images/mas.svg',
                                              id: 'different-location'
                                          }
                                      ]
                            "
                            [selectType]="'typing'"
                            [groupBy]="'group'"
                            [items]="reservation.locations"
                            [(ngModel)]="reservation.current.location"
                            (search)="onSearchLocations($event)"
                            [formControlName]="'location'"
                            (clickBtnAfter)="onClickBtnAfter($event)"
                            [loading]="loadingLocations"
                            [customSelectSearchFn]="false"
                        ></fe-input>
                    </div>
                    <div class="col-2 col-lg-auto">
                        <fe-button
                            class="d-flex mb-sm-0 mb-6 btn-search-reservation"
                            [btnClass]="
                                'px-lmd-9 d-flex justify-content-center align-items-center d-lg-block p-0 w-lmd-100'
                            "
                            [style]="'primary'"
                            [type]="'button'"
                            (onClick)="onClickUpdateLocation()"
                            [loading]="loadingUpdate"
                        >
                            {{
                                'fe_core_progress_bar_selected_button_update'
                                    | translate
                            }}
                        </fe-button>
                    </div>
                </div>
                <div
                    *ngIf="reservation.showDifferenteLocation"
                    [ngClass]="{ 'mb-md-6': formLocations.errors }"
                    class="row gx-2 d-flex justify-content-center"
                >
                    <div class="col-10 col-lg-9">
                        <fe-input
                            #differentLocationProgressBar
                            [ngClass]="{
                                'mb-0 mb-md-6': !formLocations.errors
                            }"
                            [isSelect]="true"
                            [isSelectLocations]="true"
                            [id]="'differentLocation'"
                            [label]="
                                'fe_core_progress_bar_selected_label_different-location'
                                    | translate
                            "
                            [buttonsAfter]="[
                                {
                                    text:
                                        ('fe_core_progress_bar_selected_btn_less_back-location'
                                        | translate),
                                    icon: 'images/menos_sucursales.png',
                                    id: 'different-location'
                                }
                            ]"
                            [selectType]="'typing'"
                            [groupBy]="'group'"
                            [items]="reservation.differentLocations"
                            [(ngModel)]="reservation.current.differentLocation"
                            (clickBtnAfter)="onClickBtnAfter($event)"
                            (search)="onSearchDifferentLocations($event)"
                            [formControlName]="'differentLocation'"
                            [customSelectSearchFn]="false"
                            [loading]="loadingDifferentLocations"
                        ></fe-input>
                        <fe-form-control-feedback
                            [renderComponentInvalid]="true"
                            [errors]="formLocations.errors"
                        ></fe-form-control-feedback>
                    </div>
                    <div class="col-2 col-lg-auto">
                        <fe-button
                            class="d-grid mb-sm-0 mb-6 btn-search-reservation invisible"
                            [btnClass]="'px-9'"
                            [style]="'primary'"
                            [type]="'button'"
                        >
                            {{
                                'fe_core_progress_bar_selected_button_update'
                                    | translate
                            }}
                        </fe-button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <button
        *ngIf="datetimeOpened || locationOpened"
        (click)="onClickOverlap()"
        class="container-overlap"
    >
        ''
    </button>
</div>
